import { render } from "./identifyView.vue?vue&type=template&id=11d4d126&scoped=true"
import script from "./identifyView.vue?vue&type=script&lang=js"
export * from "./identifyView.vue?vue&type=script&lang=js"

import "./identifyView.vue?vue&type=style&index=0&id=11d4d126&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11d4d126"]])

export default __exports__